import jstimezonedetect from 'jstimezonedetect';

const HEADER_AUTHORIZATION  = 'Authorization';
const HEADER_PLATFORM       = 'X-App-Platform';
const HEADER_VERSION        = 'X-App-Version';
const HEADER_TIMEZONE       = 'X-Timezone';
const HEADER_CONTENT_TYPE   = 'Content-Type';

const CONTENT_TYPE_FORM_URLENCODED = 'application/x-www-form-urlencoded';

export default class MonitoringCategorizationService {
    /* @ngInject */
    constructor($http, $q, apiService, configuration) {
        this.$http = $http;
        this.$q = $q;
        this.apiService = apiService;
        this.configuration = configuration;
    }

    categorizeLabel(label, teamCategories, labelCategoryMap) {
        let normalizedLabel = this.normalizeLabel(label);

        if (!normalizedLabel) {
            return this.$q.reject();
        }

        if (!this.apiService.token) {
            return this.$q.reject();
        }

        let url = `${this.getBaseUrl()}/categorize/label.php`;
        let data = this.formEncode({
            label: normalizedLabel,
            teamCategories: JSON.stringify(teamCategories || []),
            labelCategoryMap: JSON.stringify(labelCategoryMap || [])
        });

        return this.$http.post(url, data, {
            headers: this.buildHeaders()
        }).then((result) => result.data);
    }

    buildHeaders() {
        return {
            [HEADER_AUTHORIZATION]: this.apiService.token,
            [HEADER_PLATFORM]: this.configuration.monitoringPlatform || 'Web',
            [HEADER_VERSION]: this.configuration.version,
            [HEADER_TIMEZONE]: jstimezonedetect.determine().name(),
            [HEADER_CONTENT_TYPE]: CONTENT_TYPE_FORM_URLENCODED
        };
    }

    getBaseUrl() {
        if (PRODUCTION) {
            return this.configuration.monitoringApi || 'https://monitoring.dollarbird.co/v1';
        }

        return this.configuration.monitoringApiDev
            || this.configuration.monitoringApi
            || 'http://192.168.0.120:8100/v1';
    }

    normalizeLabel(label) {
        return String(label || '').trim().toLowerCase();
    }

    formEncode(data) {
        return Object.keys(data).map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`;
        }).join('&');
    }
}



// WEBPACK FOOTER //
// ./src/application/service/calendar/monitoring-categorization.service.js